module.exports = __webpack_public_path__ + "img/inscritos.17f569d3.png";